<template>

       <div class="container">
                <div class="page-header">
                    <div class="page-title">
                     
                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                 <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                <li>
                                  <router-link :title="' الاشعارات'" :to="{name: 'parentNotifications'}">  الاشعارات</router-link>
                                </li>
                                 <li class="active">
                                  <router-link :title="'تعديل'" :to="{name: 'parentNotifications.edit', params: {id: $route.params.id}}">تعديل</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                

                <div class="row">

                    <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12  layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">                                
                                <div class="row">
                                    <div class="col-xl-12 col-md-12 col-sm-12 col-12">
                                        <h4>
                                             <i class="flaticon-computer-4"></i> 
                                            بيانات الاشعارات</h4>
                                    </div>
                                </div>
                            </div>
                            <div class="widget-content widget-content-area">
                                <form @submit.prevent="update()">
                                  <div class="row">

                                      <div class="col-md-12">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">القالب</label>
                                            <treeselect :options="templates" :auto-load-root-options="true" v-model="data.form.notification_template_id" :multiple="false"/>
                                            <div class="invalid-feedback" :style="getErrors['notification_template_id'] ? 'display: block' : 'display: none;'"   v-if="getErrors['notification_template_id']">
                                                  {{ getErrors['notification_template_id'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-12">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">ولى الامر</label>
                                            <treeselect :options="parents" @input="refreshParent" :auto-load-root-options="true" v-model="data.form.user_id" :multiple="false"/>
                                            <div class="invalid-feedback" :style="getErrors['user_id'] ? 'display: block' : 'display: none;'"   v-if="getErrors['user_id']">
                                                  {{ getErrors['user_id'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                        <div class="col-md-12">
                                          <label for="exampleFormControlInput12">العنوان</label>
                                          <div class="input-group mb-4">
                                              
                                              <div class="input-group-prepend">
                                                <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                              </div>
                                              
                                                <input type="text" class="form-control" id="exampleFormControlInput12" v-model="data.form.title" placeholder=" العنوان ">
                                                <div class="invalid-feedback" :style="getErrors['title'] ? 'display: block' : 'display: none;'"   v-if="getErrors['title']">
                                                      {{ getErrors['title'][0] }}
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-12">
                                          <label for="exampleFormControlInput12">نص الاشعار</label>
                                          <div class="input-group mb-4">
                                              
                                              <textarea v-model="data.form.content" class="form-control" cols="30" rows="10"></textarea>
                                                <div class="invalid-feedback" :style="getErrors['content'] ? 'display: block' : 'display: none;'"   v-if="getErrors['content']">
                                                      {{ getErrors['content'][0] }}
                                                </div>
                                            </div>
                                        </div>

                                      </div>

                                    <button type="submit" class="save-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>حفظ</span></button>
                                    <button type="button" @click.prevent="resetForm" class="rewrite-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>تفريغ</span></button>
                                    <router-link class="back-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p" :to="{name: 'parentNotifications'}">
                                      <span>رجوع</span>
                                    </router-link>
                                  </form>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
</template>
<script>
import router from '@/router'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  components: {
    Treeselect,
  },
  data() {
    return {
      data: {
        checker: false,
        form:{
          title: '', 
          content: '',
          user_id: '',
          notification_template_id: ''
        },
        roles: {
        },
        options: [],
        isRequested: false,
        errors: {},
        paginated: {}
      }
    };
  },
  created(){
      this.getRequirements();
  },
  methods: {
    uploadFile() {
        this.data.form.image = this.$refs.file.files[0];
      },
       resetForm(){
        this.data.form = {
          title: '',
          content: '',
           user_id: '',
          notification_template_id: ''
        };
      },
      getInfo(){
        this.$baseApi.get('/parentNotifications/' + this.$route.params.id + '/edit').then((response)=>{
            if(response.data.code == 200 && response.data.data != null){
              console.log(response.data.data)
                this.data.form = this.dataHanlde(response.data.data.notificationTemplate);
            
            }else if(response.data.code == 404){
                router.push('/parentNotifications');
            }else{
                alert(response.data.data.error);
                router.push('/parentNotifications');
            }
        });
      },
      update(){
          this.data.isRequested = true;

        this.$baseApi.patch('/parentNotifications/' + this.$route.params.id, this.data.form).then((response)=>{
            if(response.data.code === 200){
              localStorage.setItem('flash_message', 'تمت عملية التعديل');
                router.push('/parentNotifications');
            }
        }).catch((error) => {
          this.data.errors = JSON.parse(JSON.stringify(error.response.data.errors));
          this.data.isRequested = false
        })
      },
      getRequirements(){
        this.getInfo();
      },
      getRoles(flag = false){
        if(flag){
          this.data.form.role_id = '';
        }
        
        this.$baseApi.get('/roles?pluck=1&role=' + this.data.form.role).then((response)=>{
            if(response.data.code == 200){
               this.data.roles = response.data.data;
            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
      selected(node, instanceId){
        this.form.location_id = node.id;
      },
      dataHanlde(data){
        return {
          title: data.title,
          content: data.content
        }
      },

      uploadImage(e){
                const image = e.target.files[0];
                console.log(image);
                const reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = e =>{
                  this.data.form.image = e.target.result;  
                };
      },
      getTree(){
        this.$baseApi.get('/locations?tree=true' ).then((response)=>{
            if(response.data.code == 200){
              this.data.options = response.data.data;
            }else if(response.data.code == 401){
                this.error = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
  },
  computed: {
    trans(){
      return this.$store.getters.GET_TRANS;
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    },
    getErrors() {
      return JSON.parse(JSON.stringify(this.data.errors))
    },
  }
};
</script>
<style>
</style>
